import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FiServer, FiShield, FiGlobe } from 'react-icons/fi';

// components
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import PricingSection from "../components/PricingSection";
import FeaturesSection from "../components/FeaturesSection";
import EnterpriseSection from "../components/EnterpriseSection";
import Footer from "../components/Footer";
import CookieConsentBanner from "../components/CookieConsentBanner";


//images
import logo from "../../src/assets/images/logo.png"
import featuresBG from "../../src/assets/images/features-bg.png"
import featuresSecondBG from "../../src/assets/images/featuresSecond-bg.png"
import featuresThirdBG from "../../src/assets/images/featuresThird-bg.png"
import heroBackground from "../../src/assets/images/hero-background.png"

const LandingPage = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [selectedLocation, setSelectedLocation] = useState("us");

  useEffect(() => {
    if (location.pathname !== "/") return;
    const h = (location.hash || "").replace(/^#/, "");
    if (!h || !["pricing", "features"].includes(h)) return;
    const scroll = () => {
      const el = document.getElementById(h);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const t = window.setTimeout(scroll, 80);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash]);

  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const featureBlocks = useMemo(
    () => [
      {
        title: "Advanced Threat Defense - DDOS",
        description:
          "Built-in protection shields your services from attacks, keeping your data and users safe at all times.",
        icon: FiShield,
        image: featuresBG,
        wide: false,
      },
      {
        title: "Protected Transactions",
        description:
          "Top up your balance with supported cryptocurrencies through our payment partner—simple, secure, and no credit card or PayPal required on MyRDP.",
        icon: FiServer,
        image: featuresSecondBG,
        wide: false,
      },
      {
        title: "Always-On Assistance",
        description: "Our expert support team is available 24/7 to help you whenever you need guidance or solutions.",
        icon: FiGlobe,
        image: featuresThirdBG,
        wide: true,
      },
    ],
    []
  );

  return (
    <div
      className="landing-page relative min-h-screen overflow-x-hidden bg-[#050613] text-white bg-no-repeat bg-contain bg-top"
      style={{ backgroundImage: `url(${heroBackground})` }}
    >
      {/* Mobile-only background polish */}
      <div
        className="pointer-events-none absolute inset-0 sm:hidden"
        style={{
          background:
            "radial-gradient(90% 60% at 50% 0%, rgba(11,59,240,0.28) 0%, rgba(5,6,19,0) 58%), linear-gradient(to bottom, rgba(5,6,19,0.18) 0%, rgba(5,6,19,0.86) 72%, #050613 100%)",
        }}
      />
      {/* Desktop/tablet subtle vignette */}
      <div
        className="pointer-events-none absolute inset-0 hidden sm:block"
        style={{
          background:
            "radial-gradient(70% 55% at 50% 0%, rgba(11,59,240,0.14) 0%, rgba(5,6,19,0) 60%), linear-gradient(to bottom, rgba(5,6,19,0) 0%, rgba(5,6,19,0.65) 100%)",
        }}
      />

      <Header user={user} logo={logo} scrollToSection={scrollToSection} />

      <HeroSection/> 
      <PricingSection
        user={user}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        descriptionNoWrap
      />      
      <FeaturesSection featureBlocks={featureBlocks} />
      <EnterpriseSection user={user}/>
      <Footer user={user} />

      <CookieConsentBanner />
    </div>
  );
};

export default LandingPage;
